export default __webpack_public_path__ + "static/media/video-horizontal-background-0007.0e33e432.jpg";